<div class="db-something-wrong-wrapper">
  <div>
    <img src="assets/images/icons/smth-went-wrong.svg" [alt]="'text_somethingWentWrong' | dbText" class="something-went-wrong-img mb12">
    <div class="something-went-wrong-title"><span [innerHTML]="'text_somethingWentWrong' | dbText"></span></div>
    <div *ngIf="descText" class="something-went-wrong-desc" [innerHTML]="descText"></div>
  </div>
</div>
